module.exports = __webpack_public_path__ + "img/Marta_gr.573db5e5.jpg";